import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../Input/Textarea";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";

interface RefundModalProps extends DefaultModalCommonProps {
  simplePayId: string;
  user: string;
}

export default function RefundModal({
  closeEvent,
  confirmEvent,
  simplePayId,
  user,
}: RefundModalProps) {
  const [reason, setReason] = useState("");
  const [btnClick, setBtnClick] = useState(false);
  const [askModal, setAskModal] = useState(false);

  // 환불실패 재환불
  const { response, error, loading } = useApi({
    method: "post",
    url: btnClick ? `pay/refund` : undefined,
    data: {
      id: simplePayId,
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      if (closeEvent) {
        closeEvent();
      }

      if (confirmEvent) {
        confirmEvent();
      }
      toast.success("환불이 완료되었습니다.", {});
    }
  }, [closeEvent, response]);

  useEffect(() => {
    if (error) {
      setBtnClick(false);
      toast.error(error?.data ?? "환불에 실패했습니다.");
    }
  }, [error]);

  return (
    <DefaultModalLayout
      modalTitle="100원 결제 환불"
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => setAskModal(true)}
      type="input"
      confirmDisabled={reason === ""}
      isDeleteModal={true}
    >
      <DeleteModalLabel>환불 사유</DeleteModalLabel>

      <Textarea
        placeholder="환불 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />

      <>
        {loading && <Loader />}

        {askModal && (
          <AlertModal
            title={`${user}님의\n결제가 환불됩니다.\n계속하시겠습니까?`}
            confirmEvent={() => {
              setBtnClick(true);
              setAskModal(false);
            }}
            cancelEvent={() => setAskModal(false)}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}
